import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles/tokens.css';
import './styles/app.css';
import App from './App.jsx';
import Home from './pages/Home.jsx';
import Listing from './pages/Listing.jsx';
import Detail from './pages/Detail.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import Sell from './pages/Sell.jsx';
import Favorites from './pages/Favorites.jsx';
import Compare from './pages/Compare.jsx';
import NotFound from './pages/NotFound.jsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: 'buscar', element: <Listing /> },
      { path: 'propiedad/:slug', element: <Detail /> },
      { path: 'favoritos', element: <Favorites /> },
      { path: 'comparar', element: <Compare /> },
      { path: 'vender', element: <Sell /> },
      { path: 'nosotros', element: <About /> },
      { path: 'contacto', element: <Contact /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
